import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs/index'

import {Locale} from 'vant'
import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'

import ens from './langs/enLabels.js'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: localStorage.lang || 'zh',
    messages
})
function vantLocales(lang){
    if(lang==='en'){
        Locale.use(lang,enUS)
    }else if(lang=='zh'){
        Locale.use(lang,zhCN)
    }
}
function changeStyle(lang){
    if(lang=='en'&&Vue.prototype.$isApp){
        Vue.prototype.styleEn = 'true'
    }else{
        Vue.prototype.styleEn = ''
    }
}

function en (label){
	if(!label){
		return ''
	}
	if(i18n.locale=='en'){
		let v = ens[label]
		if(v){
			return v
		}
		if(label.startsWith('请选择')||label.startsWith('请填写')){
			let left = label.substr(3)
			let s = label.substr(0,3)
			return ens[left]?ens[s+'...']+ens[left].toLowerCase():label
		}
		return label
	}
	return label
}

export {i18n,vantLocales,changeStyle,ens,en}